// extracted by mini-css-extract-plugin
export default {"form":"shippingForm_form__cPFsj","form__title":"shippingForm_form__title__CkN8w"};